import React from 'react';
import { useControls } from 'react-zoom-pan-pinch';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const SitemapControls = ({ onScreenshot, isCapturing }) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();
  
  const btnClass = "p-3 rounded-xl hover:bg-slate-50 text-slate-600 hover:text-indigo-600 transition-all active:scale-95 flex items-center justify-center disabled:opacity-50 disabled:cursor-wait";

  return (
    <div className="fixed bottom-8 right-8 flex flex-col gap-3 z-50">
      <div className="bg-white/90 backdrop-blur-xl p-2 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-white/50 flex flex-col gap-1">
        <button onClick={() => zoomIn()} className={btnClass} title="Zoom In">
          <SafeIcon icon={FiIcons.FiZoomIn} className="text-xl" />
        </button>
        <button onClick={() => zoomOut()} className={btnClass} title="Zoom Out">
          <SafeIcon icon={FiIcons.FiZoomOut} className="text-xl" />
        </button>
        
        {onScreenshot && (
          <>
            <div className="h-px bg-slate-100 w-3/4 mx-auto my-1"></div>
            <button 
              onClick={onScreenshot} 
              className={btnClass} 
              title="Download Image" 
              disabled={isCapturing}
            >
              {isCapturing ? (
                <SafeIcon icon={FiIcons.FiLoader} className="text-xl animate-spin text-indigo-600" />
              ) : (
                <SafeIcon icon={FiIcons.FiCamera} className="text-xl" />
              )}
            </button>
          </>
        )}

        <div className="h-px bg-slate-100 w-3/4 mx-auto my-1"></div>
        <button onClick={() => resetTransform()} className={btnClass} title="Reset View">
          <SafeIcon icon={FiIcons.FiMaximize} className="text-xl" />
        </button>
      </div>
    </div>
  );
};

export default SitemapControls;